import React, { useState } from "react";

function ScrapRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How does your scrap metal removal service work?",
      content: `
  We make it easy:





Get a Free Quote: Contact us for a free estimate based on the items you need removed.



Schedule Your Removal: We offer flexible scheduling, including same-day pickup services.



We Do the Work: Our team will arrive on time, load up your scrap metal, and clear everything out.



Eco-Friendly Disposal: We recycle all scrap metal responsibly, ensuring it’s processed sustainably.
      `,
    },
    {
      title: "What areas do you serve?",
      content: `
      We proudly offer scrap metal removal services in Campbell, Los Altos, Fremont, Palo Alto, Saratoga, East Palo Alto, Cupertino, Los Gatos, Mountain View, San Jose, Milpitas, Newark, Santa Clara, and Sunnyvale.
      `,
    },
    {
      title: "What items do you remove during a scrap metal removal?",
      content: `
       We remove a wide range of items, including:





Types of Metal: Ferrous, non-ferrous, stainless steel, and more.



Old Appliances: Refrigerators, washing machines, and dryers.



Automotive Parts: Car parts and junk cars.



Construction Debris: Construction material and heavy equipment.

      `,
    },
    {
      title: "Do you offer eco-friendly disposal options?",
      content: `
         Yes! We prioritize scrap metal recycling and eco-friendly disposal methods, ensuring that as much scrap metal as possible is processed responsibly.
        `,
    },
    {
      title: "How much does scrap metal removal cost?",
      content: `
          Pricing is determined by the space the scrap metal takes up on our truck, ensuring fair and transparent rates.
          `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default ScrapRemovalFAQs;
